export const App = {
    APP_HOST: 'https://bemanjarydev.com',
    API: 'https://portfolio-api.bemanjary.com/api/v1',
    TRANSLATION_API: 'https://translate-api.bemanjary.com',
    TRANSLATION_REFERENCE_KEY: 'portfolio.gence,common',
    PORTFOLIO_USER_ID: 'd2cb06ae-a897-4e01-b7ca-de80b3a048ab',
    LIMIT_PER_PAGE: 12,
};